<template>
  <div>
    <vx-card>
      <DadosGeral
        :dadosBeneficiario="form"
        :mascaras="mascaras"
        @submitDadosBeneficiario="handleFormBeneficiario"
        v-if="step === 1"
        ref="onSubmitDadosGeralRef"
      />
      <FormVeiculos
        :key="counterFormVeiculos"
        :dadosBeneficiario="form"
        :veiculosProposta="veiculosProposta"
        :geraPropostaMoto="geraPropostaMoto"
        @submitDadosVeiculos="handleFormVeiculos"
        v-if="step === 2"
        ref="onSubmitDadosVeiculosRef"
      />
      <ListVeiculos
        :key="counterListVeiculos"
        :listVeiculosProposta="listVeiculosProposta"
        v-if="step === 3"
        :decoded="decoded"
        ref="onSubmitDadosPropostasFrotaRef"
        @submitDadosVeiculos="handleDadosPropostaFrota"
      />
      <formasPagamento
        v-if="step === 4"
        :tokenDecoded="decoded"
        :propostas="propostasFrota"
        :idProspect="null"
        @submitDadosFormasPagamento="handleDadosFormasPagamento"
        ref="onSubmitDadosFormasPagamentoRef"
      />
      <div class="flex flex-col sm:flex-row justify-between lg:mx-5">
        <vs-button
          color="dark"
          @click.stop.prevent="voltar()"
          type="border"
          class="mt-2 mb-2 w-full sm:w-auto"
        >
          Voltar
        </vs-button>
        <vs-button
          v-if="step != 4"
          color="success"
          @click.stop.prevent="avancar()"
          class="mt-2 mb-2 w-full sm:w-auto"
        >
          Avançar
        </vs-button>
        <vs-button
          v-if="step === 4"
          color="success"
          @click.stop.prevent="salvarPropostas()"
          class="mt-2 mb-2 w-full sm:w-auto"
        >
          Concluir e finalizar
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>
<script>
import formasPagamento from './components/formasPagamento.vue';
import FormVeiculos from './components/FormVeiculos.vue';
import DadosGeral from './components/dadosGeral.vue';
import ListVeiculos from './components/listVeiculos.vue';
import jwt from 'jsonwebtoken';
import service from '../../../../services';
import regionaisService from '../../../../services/regionais';
import { deepClone } from '../../../../utils/deepClone';
import { decryptData } from '../../../../services/decryptData';

export default {
  components: {
    formasPagamento,
    FormVeiculos,
    DadosGeral,
    ListVeiculos,
  },
  data() {
    return {
      counterFormVeiculos: 0,
      counterListVeiculos: 0,
      step: 1,
      decoded: null,
      divisoes: [],
      regionais: [],
      idUsuario: null,
      form: {
        origemCadastroProposta: window.location,
        caminhao: false,
        implemento: false,
        agregado: false,
        somenteAgregado: false,
        valorTotalConjunto: 0,
        valorCobertura: 0,
        idEmpresa: null,
        tipoProposta: null,
        idGrupo: {},
        regional: {},
        idDivisao: null,
        nome: null,
        email: '',
        telefone: null,
        precoVeiculo: 0,
        cidade: '',
        estado: null,
        endereco: null,
        bairro: null,
        cep: null,
        placa: '',
        isZero: false,
        idMarcaParticipacao: null,
        idModeloParticipacao: null,
        restricoesSelecionadas: [],
        nf: null,
        dataNf: null,
        valorNf: 0,
        chassi: null,
        numeroMotor: null,
        renavam: null,
        combustivel: null,
        cor: null,
        valor: 0,
        permiteInvoiceSelfService: false,
        idTipoDesconto: '',
        habilitaAlterarGrupo: false,
        alterarGrupoVeiculoCotacao: null,
        dadosFinanceiros: {
          mensais: null,
          avista: null,
        },
        dadosUtm: [],
        origemLead: null,
        comissaoAplicada: 0,
        valorComissaoAplicadaFinal: 0,
        is1app: false,
        idUser1app: '',
      },
      veiculosProposta: [],
      listVeiculosProposta: [],
      propostasFrota: [],
      propostasFrotaFormasPagamento: [],
      mascaras: {
        mascaraCarro: null,
        mascaraMoto: null,
        mascaraCaminhao: null,
        mascaraAgregado: null,
        mascaraImplemento: null,
        ativaMascarasVeiculos: null,
      },
      geraPropostaMoto: true,
    };
  },
  methods: {
    avancar() {
      if (this.step === 1) {
        const valid = this.$refs.onSubmitDadosGeralRef.onSubmit();
        if (!valid) {
          return;
        }
      }

      if (this.step === 2) {
        const valid = this.$refs.onSubmitDadosVeiculosRef.onSubmit();
        if (!valid) {
          return;
        }
      }

      if (this.step === 3) {
        const valid = this.$refs.onSubmitDadosPropostasFrotaRef.onSubmit();
        if (!valid) {
          return;
        }
      }
      this.step++;
    },

    voltar() {
      this.step > 1
        ? (this.step = this.step - 1)
        : this.$router.push('/novaProposta/Interno');

      if (this.step === 1) {
        this.veiculosProposta = [];
        this.counterFormVeiculos++;
        this.form.tipoProposta = null;
      }

      if (this.step === 2) {
        this.listVeiculosProposta = [];
        this.counterListVeiculos++;
      }
    },

    handleFormBeneficiario(dadosFormulario) {
      this.form = { ...this.form, ...dadosFormulario };
    },

    handleFormVeiculos(veiculos) {
      this.listVeiculosProposta = deepClone(veiculos);
    },

    handleDadosFormasPagamento(propostasAtualizadas) {
      this.propostasFrotaFormasPagamento = deepClone(propostasAtualizadas);
    },

    handleDadosPropostaFrota(propostasFrotasAtualizado) {
      this.propostasFrota = deepClone(propostasFrotasAtualizado);
    },

    async getIdEmpresa() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.form.idEmpresa = this.decoded.id_empresa;
        this.form.idUsuarioConsultor = this.decoded.id_usuario;
      }

      this.idUsuario = this.decoded.id_usuario;

      this.buscaDadosRegionais();
    },

    async buscaDadosEmpresa() {
      try {
        const { data } = await service.getAll(
          'g',
          {},
          `empresas/list/idEmpresa/${this.form.idEmpresa}`,
        );
        const _data = decryptData(data);

        const [resultEmpresa] = _data;

        this.liberaPropostaMotoNaRua = resultEmpresa.liberaPropostaMotoNaRua;
        this.permitirRestricoes = resultEmpresa.permitirRestricoes;
        this.permitePlacaRepetida = resultEmpresa.permiteVariasCotacoesPorPlaca;
        this.form.alterarGrupoVeiculoCotacao =
          resultEmpresa.alterarGrupoVeiculoCotacao;
        this.geraPropostaMoto = resultEmpresa.geraPropostaMoto;

        if (this.form.alterarGrupoVeiculoCotacao) {
          this.form.habilitaAlterarGrupo = true;
        }

        if (resultEmpresa.ativaMascarasVeiculos) {
          (this.mascaras.mascaraCarro = resultEmpresa.mascaraCarro),
            (this.mascaras.mascaraMoto = resultEmpresa.mascaraMoto),
            (this.mascaras.mascaraCaminhao = resultEmpresa.mascaraCaminhao),
            (this.mascaras.mascaraAgregado = resultEmpresa.mascaraAgregado),
            (this.mascaras.mascaraImplemento = resultEmpresa.mascaraImplemento);
          this.mascaras.ativaMascarasVeiculos =
            resultEmpresa.ativaMascarasVeiculos;
        }

        this.logo = resultEmpresa.logo;
      } catch (error) {
        this.erroConexao =
          'Seu aplicativo parece estar offline, verifique sua conexão';
        throw error;
      }
    },

    async buscaDadosRegionais() {
      this.$vs.loading();
      this.regionais = [];
      const objSend = {};
      objSend.idEmpresa = !this.$route.params.idEmpresa
        ? this.form.idEmpresa
        : this.$route.params.idEmpresa;

      try {
        this.regionais = await regionaisService.buscaRegionaisUsuario(
          this.idUsuario,
          objSend,
        );

        const regionalSelecionada = this.regionais.find(
          (regional) => regional.id === Number(this.form.regional.id),
        );

        const { permitePlacaDuplicada } = await this.buscarDadosRegional(
          regionalSelecionada.id,
        );

        this.form.regional = {
          ...regionalSelecionada,
          permitePlacaDuplicada,
        };
      } catch (e) {
        this.notifyMsg('warning', 'Falha ao buscar os Regionais e Divisões');
      }
      this.idRegionais = this.regionais.map((item) => item.id);
      this.buscouRegionais = true;
      this.$vs.loading.close();
      this.buscaDivisoes();
    },

    async buscarDadosRegional(idRegional) {
      try {
        const { data } = await service.post(
          'RegionalAberta',
          `find/${idRegional}`,
          {},
        );
        return data;
      } catch (error) {
        this.notifyMsg('danger', 'Falha ao buscar dados da regional', 5000);
      }
    },

    notifyMsg(color, msg, timer = 2000) {
      return this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: msg,
        color: color,
        timer,
      });
    },

    async buscaDivisoes() {
      const { idEmpresa, userName } = this.$route.params;
      const page = this.$route.name;
      const ID_EMPRESA_LANDING_PAGE = 120;

      const _idEmpresa =
        !idEmpresa && page == 'landingPageBP'
          ? ID_EMPRESA_LANDING_PAGE
          : idEmpresa;

      if (this.form.regional) {
        var objSend = {
          idRegional: this.form.regional.id,
          idEmpresa: _idEmpresa,
          userName,
        };

        this.$vs.loading();
        try {
          const divisoes = await regionaisService.buscaDivisoes(objSend);
          this.divisoes = divisoes;
          this.form.idDivisao = this.divisoes[0].id;
          this.buscouDivisoes = true;
        } catch (e) {
          this.notifyMsg('danger', 'Falha ao buscar os Regionais e Divisões');
        } finally {
          this.$vs.loading.close();
        }
      }
    },

    preencheDadosProposta() {
      const { idDivisao, idRegional } = this.$route.query;
      this.form.idDivisao = idDivisao;
      this.form.regional.id = idRegional;
      this.definirDadosRegional();
    },

    async definirDadosRegional() {
      try {
        const { permitePlacaDuplicada } = await this.buscarDadosRegional(
          this.form.regional.id,
        );

        const regional = {
          ...this.form.regional,
          permitePlacaDuplicada,
        };

        this.form.regional = regional;
      } catch (error) {
        this.notifyMsg('danger', 'Falha ao definir os dados da regional', 5000);
      }
    },

    async gerarIdFrota() {
      try {
        const resultGerarIdFrota = await service.post(
          'Cotacao',
          'gerar-id-frota',
          {
            idEmpresa: this.decoded.id_empresa,
          },
        );

        const idFrota = resultGerarIdFrota.data.idFrota;
        return idFrota;
      } catch (error) {
        this.notifyMsg('danger', 'Falha ao gerar um ID da frota.', 5000);
      }
    },

    gerarPropostasComIdFrota(idFrota) {
      const propostasComIdFrota = this.propostasFrotaFormasPagamento.map(
        (proposta) => {
          return { ...proposta, idFrota };
        },
      );
      return propostasComIdFrota;
    },

    async salvarPropostas() {
      try {
        this.$vs.loading();

        const valid =
          await this.$refs.onSubmitDadosFormasPagamentoRef.validaCamposPreenchidos();

        if (!valid) {
          return;
        }

        const idFrota = await this.gerarIdFrota();
        const propostasFrotaFormasPagamentoComIdFrota =
          this.gerarPropostasComIdFrota(idFrota);

        await service.post(
          'Cotacao',
          'enviar-multiproposta-s3',
          propostasFrotaFormasPagamentoComIdFrota,
        );

        this.notifyMsg(
          'success',
          `Suas propostas estão sendo criadas. Aguarde um pouco e atualize o painel de propostas.`,
          8000,
        );
        this.$router.push('/dashboard');
      } catch (error) {
        this.notifyMsg('danger', `Erro: ${error}`, 5000);
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  mounted() {
    this.preencheDadosProposta();
  },
  async created() {
    await this.getIdEmpresa();
    await this.buscaDadosEmpresa();
  },
};
</script>
